export const profileColumns = () => [
  {
    field: 'id',
    headerName: 'Id',
    width: 100,
    editable: false,
  },
  {
    field: 'title',
    headerName: 'Nome',
    flex: 1,
    editable: false,
  },
  {
    field: 'description',
    headerName: 'Descrição',
    editable: false,
    flex: 1,
    width: 300,
  },
]

export const TABLE_SX = {
  fontSize: '1.4rem',
  width: '100%',

  '& .MuiDataGrid-virtualScrollerRenderZone': {
    width: '100%',
  },

  '& .MuiDataGrid-row': {
    width: '100%',
  },

  '& .MuiDataGrid-cell': {
    width: '100%',
  },

  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },

  '& .MuiDataGrid-columnHeader': {
    width: '100%',
  },
}
